import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { IconButton } from 'shared/ui/IconButton'
import styles from './styles.module.scss'

type IUnifiedMessageFieldProps = {
  placeholder: string
  value: string
  hoveredChipId?: string | null
  handleChange: (value: string) => void
  handleSubmit: () => void
  disabledBtn?: boolean
  disabled?: boolean
  className?: string
}

export const UnifiedMessageField = observer(
  ({
    placeholder,
    value,
    hoveredChipId,
    handleChange,
    handleSubmit,
    disabled,
    disabledBtn,
    className,
  }: IUnifiedMessageFieldProps) => {
    return (
      <div className={classnames(styles.inputWrap, className)}>
        <textarea
          className={classnames(styles.textarea, {
            [styles.textarea_chipPlaceholder]: !!hoveredChipId,
          })}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              if (value) handleSubmit()
            }
          }}
        />
        <IconButton
          icon='arrowUp'
          color='primary'
          variant='contained'
          size='medium'
          disabled={disabledBtn || disabled}
          ariaLabel='CreateAgentModal'
          onClick={() => handleSubmit()}
          className={styles.submitButton}
        />
      </div>
    )
  }
)
